import { render, staticRenderFns } from "./PricesServiceCalendar.vue?vue&type=template&id=1de2ff28&scoped=true&"
import script from "./PricesServiceCalendar.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PricesServiceCalendar.vue?vue&type=script&lang=ts&setup=true&"
import style0 from "./PricesServiceCalendar.vue?vue&type=style&index=0&id=1de2ff28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de2ff28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1de2ff28')) {
      api.createRecord('1de2ff28', component.options)
    } else {
      api.reload('1de2ff28', component.options)
    }
    module.hot.accept("./PricesServiceCalendar.vue?vue&type=template&id=1de2ff28&scoped=true&", function () {
      api.rerender('1de2ff28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPrices/components/PricesServiceCalendar.vue"
export default component.exports